/**
 * Maps the engine-expected on-device filenames (`img_YYYY-MM-DD_HHMMSS_N.ext` /
 * `vid_YYYY-MM-DD_HHMMSS_N.ext` — the prefix + date pattern `HuntingProductSyncEffects` filters
 * and parses `capturedAt` from) to bundled asset paths served by the app itself.
 *
 * Every referenced asset must pass the sync engine's own file-integrity check (`file-integrity.util.ts`:
 * valid JPEG magic bytes, or a real MP4 with a `moov` atom) — a placeholder/corrupt file here fails
 * sync with a hard error, not a warning.
 */
export interface MockHuntingDeviceFile {
  /** Device-side month directory, e.g. `2025-01` — mirrors `HuntingProductSyncEffects`' FTP layout. */
  monthDir: string;
  /** Device-side filename the sync engine sees over the mock transport. */
  deviceFileName: string;
  /** App-relative asset path (served from `/assets/...`, base href is `/`). */
  assetPath: string;
}

export const MOCK_HUNTING_DEVICE_MEDIA: Array<MockHuntingDeviceFile> = [
  { monthDir: '2018-05', deviceFileName: 'img_2018-05-23_104110_1.jpg', assetPath: '/assets/cannes-mock-data/img_2018-05-23_104110_1.jpg' },
  { monthDir: '2018-05', deviceFileName: 'vid_2018-05-23_104115_1.mp4', assetPath: '/assets/cannes-mock-data/vid_2018-05-23_104115_1.mp4' },
  { monthDir: '2018-05', deviceFileName: 'img_2018-05-23_104120_1.jpg', assetPath: '/assets/cannes-mock-data/img_2018-05-23_104120_1.jpg' },
  { monthDir: '2018-05', deviceFileName: 'img_2018-05-23_104124_1.jpg', assetPath: '/assets/cannes-mock-data/img_2018-05-23_104124_1.jpg' },
  { monthDir: '2018-05', deviceFileName: 'vid_2018-05-30_102449_1.mp4', assetPath: '/assets/cannes-mock-data/vid_2018-05-30_102449_1.mp4' },
  { monthDir: '2018-05', deviceFileName: 'img_2018-05-30_102538_1.jpg', assetPath: '/assets/cannes-mock-data/img_2018-05-30_102538_1.jpg' },
  { monthDir: '2018-05', deviceFileName: 'img_2018-05-30_102545_1.jpg', assetPath: '/assets/cannes-mock-data/img_2018-05-30_102545_1.jpg' },
  { monthDir: '2018-05', deviceFileName: 'vid_2018-05-30_102547_1.mp4', assetPath: '/assets/cannes-mock-data/vid_2018-05-30_102547_1.mp4' },
  { monthDir: '2018-05', deviceFileName: 'img_2018-05-30_102632_1.jpg', assetPath: '/assets/cannes-mock-data/img_2018-05-30_102632_1.jpg' },
];
